export default __webpack_public_path__ + "static/BoschSans-Regular-346cae9c213e60281cb45665f8bb0ba8.ttf";